// External Dependencies:
import React from 'react'

class WaypointDistance extends React.Component {
	constructor() {
		super()

		this.ref = React.createRef()
		this.state = {
			inViewport: false
		}
	}

	componentDidMount() {
		window.addEventListener( 'scroll', this.throttledScroll )
		window.addEventListener( 'resize', this.throttledScroll )
	}

	componentWillUnmount() {
		window.removeEventListener( 'scroll', this.throttledScroll )
		window.removeEventListener( 'resize', this.throttledScroll )
	}

	throttledScroll = () => {
		requestAnimationFrame( () => {
			this.handleScroll()
		} )
	}

	// calculateOpacity = ( distance ) => {
	// 	if ( distance === 0 ) return 1

	// 	if ( Math.abs( distance ) >= window.innerWidth / 2 ) return 0

	// 	return 1 - Math.abs( distance ) / ( window.innerWidth / 2 )
	// }

	handleScroll = () => {
		const centerY = window.innerHeight / 2
		// const viewportCenterY = window.innerHeight / 2 + window.scrollY
		const elementRect = this.ref.current.getBoundingClientRect()
		// const elementCenterY = elementRect.top + elementRect.height / 2
		const distance = centerY - elementRect.top

		if ( 1 == this.props.data ) {
			// console.log( viewportCenterY, 'viewportCenterY' );
			// console.log( elementRect, 'elementRect' );
			// console.log( distance, 'distance' );
		}

		// if ( distance > window.innerHeight ) {
		if ( distance >= -window.innerHeight && distance <= window.innerHeight ) {
			this.props.onChange( distance, this.props.data )
			// console.log( this.props.data, distance )
		}

		// const elementHeight = 1000
		// const windowHeight = window.innerHeight
		// const distanceFromCenter = Math.abs( scrollY + ( windowHeight / 2 ) - ( elementTop + ( elementHeight / 2 ) ) )
		// const maxDistance = windowHeight / 2 + elementHeight / 2
		// const calculatedOpacity = 1 - distanceFromCenter / maxDistance
		// const opacity = Math.max( 0, calculatedOpacity )


	}

	render() {
		return (
			<span className="waypoint-distance" ref={ this.ref } style={ { fontSize: 0 } }></span>
		)
	}
}

export default WaypointDistance


// WEBPACK FOOTER //
// ./components/Waypoint/WaypointDistance.jsx